import { render, staticRenderFns } from "./CreateServe.vue?vue&type=template&id=5c9f1c64&scoped=true&"
import script from "./CreateServe.vue?vue&type=script&lang=js&"
export * from "./CreateServe.vue?vue&type=script&lang=js&"
import style0 from "./CreateServe.vue?vue&type=style&index=0&id=5c9f1c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f1c64",
  null
  
)

export default component.exports